import { render, staticRenderFns } from "./ComputeResource.vue?vue&type=template&id=3f7a6fa3&scoped=true&"
import script from "./ComputeResource.vue?vue&type=script&lang=js&"
export * from "./ComputeResource.vue?vue&type=script&lang=js&"
import style0 from "./ComputeResource.vue?vue&type=style&index=0&id=3f7a6fa3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7a6fa3",
  null
  
)

export default component.exports